'use client';

import { isServer, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { GlobalSourcePageTrackerProvider } from '@/context/sourcePageTracker/sourcePageTrackerProvider';
import PageStateProvider from '@/context/pageStates/pageStateProvider';
import AppWrapper from '@/components/AppWrapper';
import LayoutConfigProvider from '@/context/layoutConfig/layoutConfigProivder';
import AuthProvider from '@/context/auth/authProvider';
import AudioPlayerProvider from '@/context/audioPlayer/audioPlayerReducer';

function makeQueryClient() {
    return new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 30 * 60 * 1000,
                refetchOnWindowFocus: false,
                gcTime: 60 * 60 * 1000
            }
        }
    });
}

let browserQueryClient: QueryClient | undefined = undefined;

function getQueryClient() {
    if (isServer) {
        return makeQueryClient();
    } else {
        if (!browserQueryClient) browserQueryClient = makeQueryClient();
        return browserQueryClient;
    }
}

export default function Providers({ children }) {
    const queryClient = getQueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <AuthProvider>
                <LayoutConfigProvider>
                    <GlobalSourcePageTrackerProvider>
                        <PageStateProvider>
                            <AudioPlayerProvider>
                                <AppWrapper>{children}</AppWrapper>
                            </AudioPlayerProvider>
                        </PageStateProvider>
                    </GlobalSourcePageTrackerProvider>
                </LayoutConfigProvider>
            </AuthProvider>
        </QueryClientProvider>
    );
}
